import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'
import EditIcon from '@material-ui/icons/Edit'

function EdicionData (props) {
  const { actualizar, titulo, contenido } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleUpdate = () => {
    actualizar()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleUpdate}
          title={titulo}
          content={contenido}
        />
      </Dialog>
      <Tooltip title={'Editar'}>
        <IconButton onClick={handleOpen} style={{ outline: 'none' }}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

export default EdicionData
